<template>
  <generic-loader v-if="loading" />
  <div v-else>
    <div class="lyon-display-medium-24">Videos</div>
    <div v-if="workshopVideos.length === 0">
      <span class="text-muted regular-14">No result</span>
    </div>
    <div v-else class="mt-2">
      <b-card v-for="(video, index) in workshopVideos" :key="index">
        <div class="medium-18 mb-2">Speakers :</div>
        <div class="regular-16 mb-3">
          <speaker :speakers="video.speakers" />
        </div>

        <div class="medium-18 mb-2">Video :</div>
        <div v-if="video.video_file" class="regular-16 mb-2 my-2">
          <div class="regular-16 typo-color-blue custom-html-text mb-2">
            <a :href="video.video_file.video_file_url">
              <div class="mb-2">
                <span v-if="video.video_file.data_file_name">{{ video.video_file.data_file_name }}</span>
                <span v-else-if="video.video_file.name">
                  {{ video.video_file.name }}
                </span>
                <span v-else-if="video.name">
                  {{ video.name }}
                </span>
                <span v-else>Watch Vimeo Video</span>
                <a v-if="canEditCms" :href="fetchLegacyUrl(`/workshops/${$route.params.id}/schedules/${video.videoable_id}`)">
                  <i
                    v-b-tooltip.hover.top="'Edit'"
                    class="fas fa-edit cursor-pointer ml-2"
                    style="color:green"
                  />
                </a>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <VideoViewSection :video="video.video_file" />
                </div>
              </div>
            </a>
          </div>
        </div>
        <div v-else class="text-muted regular-14">
          No Video Available
        </div>

        <div class="medium-18 mb-2">Abstract :</div>
        <div
          v-if="video.ws_schedule.abstract"
          class="regular-16 custom-html-text"
          v-html="video.ws_schedule.abstract"
        />
        <div v-else class="text-muted regular-14">No Abstract Data</div>

        <div class="medium-18 mb-2 mt-2">Supplements :</div>
        <div v-if="video.document.length > 0">
          <div v-for="(supplement, index) in video.document" :key="index">
            <div class="regular-16 mb-2 my-2">
              <span>{{ supplement.name }}</span>
              <router-link :to="{
                name: 'schedule-edit-supplement',
                params: {supplementId: supplement.id}}"
              >
                <i
                  v-if="canEditCms"
                  v-b-tooltip.hover.top="'Edit'"
                  class="fas fa-edit cursor-pointer ml-2"
                  style="color:green"
                />
              </router-link>
              <!-- <i
                v-if="canEditCms"
                v-b-tooltip.hover.top="'Delete'"
                class="fas fa-trash cursor-pointer ml-2"
                style="color:red"
                @click="deleteScheduleSupplement(supplement.id)"
              /> -->
            </div>
            <div v-if="supplement.document_file.length > 0">
              <div v-for="(item, i) in supplement.document_file" :key="i">
                <div class="regular-16 typo-color-blue mb-2">
                  <a :href="item.asset_path">
                    {{ item.data_file_name }}
                  </a>
                  <a :href="item.download_asset_path">
                    <i class="fa fa-download ml-2" aria-hidden="true" />
                  </a>
                </div>
                <div class="regular-16 text-muted mb-2">
                  {{ item.data_content_type }} - {{ item.file_size }}
                </div>
              </div>
            </div>
            <div v-else>
              <span class="text-muted regular-14">No File Available</span>
            </div>
          </div>
        </div>
        <div v-else>
          <span class="text-muted regular-14">No Supplements Available</span>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js'
import { mapGetters } from 'vuex'
import Speaker from '@/components/CommonPages/Speaker.vue'
import GenericLoader from "@/components/Loaders/GenericLoader.vue"
import VideoViewSection from '@/components/CommonPages/VideoViewSection.vue'

export default {
  name: 'WorkshopVideoTabSection',
  components: { Speaker, GenericLoader, VideoViewSection },
  mixins: [mixin],
  props: ['data'],
  computed: {
    ...mapGetters(['canEditCms'])
  },
  data() {
    return {
      workshopVideos: [],
      loading: true
    }
  },
  mounted() {
    this.loadWorkshopVideos()
  },
  methods: {
    loadWorkshopVideos () {
      this.loading = true
      this.$http.get(process.env.VUE_APP_API_URL + `/workshops/${this.$route.params.id}/workshop_videos`)
      .then((res) => {
        this.workshopVideos = res.data.workshop_videos
        this.loading = false
      })
    }
  }
}
</script>
